import { v4 as uuidv4 } from 'uuid'

// Offline-first identity primitives shared by every optimistic store.
//
// A locally-creatable entity has no server id until its create syncs. Instead of
// baking a (possibly null) server id into each queued action, every entity gets a
// stable client-minted `clientId` at create time; actions reference the clientId,
// and the sync layer resolves the server id live at run time from whichever source
// currently holds it (synced base data, or the entity's own create action once the
// server has answered). This keeps the online and offline paths reading the same
// identity and removes the whole class of "id not found" drift.

export function newClientId(): string {
  return uuidv4()
}

// First non-null server id in priority order (base data before create-action, etc.).
export function pickServerId(...candidates: (string | null | undefined)[]): string | null {
  for (const candidate of candidates) {
    if (candidate) return candidate
  }
  return null
}
